import React from 'react';
import styled, { TC } from '@benzinga/themetron';
import { ChatBadge as ChatBadgeType, ChatBadgeName } from '@benzinga/chat-manager';
import { avatarColor } from './ChatAvatar';

interface Props {
  badge: ChatBadgeType;
  onClick?(): void;
}

export const ChatBadge: React.FC<Props> = ({ badge: { name }, onClick }) => (
  <Badge $name={name} onClick={onClick}>
    {name}
  </Badge>
);

interface ChatBadgeProps {
  $name: ChatBadgeName;
}

const Badge = styled(TC.Row).attrs<
  ChatBadgeProps & {
    color?: string;
  }
>(props => {
  let color: string;

  switch (props.$name) {
    case 'pro':
      color = props.theme.colors.brand;
      break;

    case 'admin':
      color = props.theme.colors.statistic.positive;
      break;

    case 'trial':
      color = props.theme.colors.accent;
      break;

    default:
      color = avatarColor(props.$name);
      break;
  }

  return {
    color,
  };
})<ChatBadgeProps>`
  align-self: center;
  border-radius: 0.25em;
  border: 1px solid ${props => props.color};
  font-size: 0.625em;
  font-weight: bold;
  margin: 0px 5px 2px 2px;
  padding: 0.2em 0.4em;
  text-transform: uppercase;
  background-color: unset;
  color: ${props => props.color};
`;
